// Allow for smooth scrolling and offset when clicking anchor links
$(document).on('click', 'a[href^="#"]', function (event) {
    if (!$(this).closest(".instafeed-shopify").length) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 150
        }, 500);
    }
});

$(document).ready(function () {
    $('.enabled_special_order').on('click', function (event) {
        event.preventDefault();
        const variant_name = $('.options-selection__option-name span').text();
        const link = $(this).data('mailto').replace('variant_title', variant_name);
        window.location = link;
        return false;
    })
})

// Code for the "Show nore" and "Show less" button within the Instructions tab found on product pages
$(".expand-toggle").click(function (e) {
    e.preventDefault();

    var $this = $(this);
    var expandHeight = $this.prev().find(".inner-bit").height();

    if ($this.prev().hasClass("expanded")) {
        $this.prev().removeClass("expanded");
        $this.prev().attr("style", "");
        $this.html("Show more");

        var position = $this.prev().offset().top - 200;

        $('html, body').stop().animate({
            'scrollTop': position
        }, 350, 'swing');

    } else {
        $this.prev().addClass("expanded");
        $this.prev().css("max-height", expandHeight);
        $this.html("Show less");
    }

});
